import roninBrand from './brands/ronin';
import pulseBrand from './brands/pulse';

const theme = process.env.REACT_APP_THEME || 'ronin';

console.log('Current theme:', process.env.REACT_APP_THEME);

const brandMap = {
  ronin: roninBrand,
  pulse: pulseBrand
};

const brand = brandMap[theme] || roninBrand;

export const webURL = brand.hmLink || 'https://www.artoflogic.ai';

export const BRAND_LOGO = brand.BRAND_LOGO || '../themes/ronin/homepage.gif';

export const card1Text = 'ALPR-powered vehicle recognition and parking enforcement. Track license plates and ensure smooth access, security, and compliance.';
export const card2Text = 'Advanced people and object detection with Re-ID. Track movement, dwell time, queues, and crossing lines for precise insights. Enhance operations with real-time analytics and BI integration.';
export const card3Text = 'Real-time diagnostics, proactive alerts, and centralized insights to prevent downtime and optimize performance.';


export const policyNames = [
    '1-Channel Samurai Count',
    '2-Channel Samurai Count',
    '4-Channel Samurai Count',
    '1-Channel Samurai Detect',
    '2-Channel Samurai Detect',
    '4-Channel Samurai Detect',
    '6-Channel Health Monitoring',
    '50-Channel Health Monitoring',
    '100-Channel Health Monitoring',
    '4-Channel Parking Management',
    '2-Channel Parking Management',
    '4-Channel Corsight',
    '2-channel Object',
    '50-Channel Health Monitoring Demo',
    '4-Channel Samurai Count Demo',
    '4-Channel Samurai Detect Demo',
    '1-Channel BASE DEMO',
    '2-Channel BASE DEMO',
    '4-Channel BASE DEMO',
    '8-Channel BASE DEMO',
    '1-Channel Base Suite',
    '2-Channel Base Suite',
    '3-Channel Base Suite',
    '4-Channel Base Suite',
    '5-Channel Base Suite',
    '6-Channel Base Suite',
    '7-Channel Base Suite',
    '8-Channel Base Suite',
    '9-Channel Base Suite',
    '10-Channel Base Suite',
    '11-Channel Base Suite',
    '12-Channel Base Suite',
    '13-Channel Base Suite',
    '14-Channel Base Suite',
    '15-Channel Base Suite',
    '16-Channel Base Suite',
    '17-Channel Base Suite',
    '18-Channel Base Suite',
    '19-Channel Base Suite',
    '20-Channel Base Suite',
    '21-Channel Base Suite',
    '22-Channel Base Suite',
    '23-Channel Base Suite',
    '24-Channel Base Suite',
    '1-Channel LPR DEMO',
    '2-Channel LPR DEMO',
    '4-Channel LPR DEMO',
    '1-Channel LPR',
    '2-Channel LPR',
    '4-Channel LPR',
    '1-Channel Infringement DEMO',
    '2-Channel Infringement DEMO',
    '4-Channel Infringement DEMO',
    '1-Channel Infringement',
    '2-Channel Infringement',
    '4-Channel Infringement',
  ];

  export const reportFooter = '© 2023 Art of Logic Pty Ltd. All rights reserved.';

  export const siteSetupInstructionLink = 'https://www.youtube.com/embed/l3qJ2Uh944E';

  export const nxWitnessPdfGuide = '/AOL-RONIN-Installer-Guide-Nx.pdf';
  export const milestonePdfGuide = '/AOL-RONIN-Installer-Guide-Milestone.pdf';
  export const avigilonPdfGuide = '/AOL-RONIN-Installer-Guide-Avigilon.pdf';
  export const wisenetPdfGuide = '/AOL-RONIN-Installer-Guide-WisenetWave.pdf';
  export const dwSpectrumPdfGuide = '/AOL-RONIN-Installer-Guide-DWSpectrum.pdf';

  export const MFAGuide = '/MFA-Install-Guide.docx';

  export const contactNum = '1300 300 123';
  export const contactNumNoSpace = '1300300123';

  // Export brand-specific values
  export const contactEmail = brand.contactEmail || 'sales@artoflogic.ai';
  export const contactEmailSupport = brand.contactEmailSupport || 'support@artoflogic.ai';
  export const hmLink = brand.hmLink || 'https://ronin.artoflogic.ai';
  export const businessLink = brand.businessLink || 'https://www.artoflogic.ai';
  
  export const application = brand.application || 'Ronin';

  export const business = brand.business || 'AOL';

  export const fullBusiness = brand.fullBusiness || 'Art of Logic';

  export const businessAddress = 'Innovation House | Suite 35<br/>50 Mawson Lakes Blvd, Mawson Lakes SA 5095';

  // FAQs page
  export const faqs = [
    {
      question: 'What are the system requirements to install and access the RONIN configuration interface?',
      answer: 'A Linux machine (AMD64 or ARM64) with Docker installed and running, plus sudo privileges.',
    },
    {
      question: 'How do I run the RONIN installation script?',
      answer: 'Copy the script from ronin_script.txt (for AMD64) or ronin_script_arm.txt (for ARM64) and paste it into your terminal.',
    },
    {
        question: 'Does Windows show a security warning when downloading or installing Ronin (ronin.exe)?',
        answer: 'Yes. When downloading or installing the Ronin Windows installer (ronin.exe), Windows may display security warnings because the application is not yet widely recognized. Ronin is safe to install and does not contain any harmful software. You can confidently proceed by selecting “Keep anyway”, “Run anyway”, or “Allow” when prompted.',
    },
    {
      question: 'How do I access the RONIN configuration interface?',
      answer: 'Visit 127.0.0.1:47274 if on the same device or [local IP]:47274 from another device on the network. For example, if the local network IP address is 192.168.1.2, this would be 192.168.1.2:47274.',
    },
    {
        question: 'Where do I find the business token for the configuration?',
        answer: 'It is a unique token from your Health Monitoring Portal under your user icon on the right at https://ronin.artoflogic.ai.',
    },
    {
        question: 'What credentials do I need to configure my NX server?',
        answer: 'Enter the NX server IP (127.0.0.1 if on the same device, or local network IP) and your NX admin username and password.',
    },
    {
        question: 'Can I monitor Katana switches with RONIN? How?',
        answer: "Yes. Tick the checkbox during setup and provide each switch's IP address, username, and password. You can add as many Katana switches as you need.",
    },
    {
        question: 'How do I add additional IP devices such as a UPS?',
        answer: 'In the setup interface, choose the type as UPS then enter a name and IP address under the “Additional Devices” section. You can add as many UPS devices as you need.',
    },
    {
        question: 'Who is the System Integrator and where do I enter their details?',
        answer: 'The System Integrator is the person/company managing this install. Their name is entered during configuration.',
    },
    {
        question: 'How do I validate my RONIN license key?',
        answer: 'Go to the top menu and select “validate-licensing.” Enter your purchased license key in the field provided.',
    },
    {
        question: 'How do I set the location of my site using the mapping tool?',
        answer: 'Either drag the map pin to the correct location and zoom in to fine-tune, or manually enter latitude and longitude.',
    },
    {
        question: 'Where can I purchase a license key?',
        answer: 'You can purchase them from www.artoflogic.ai or reach out to sales@artoflogic.ai for further guidance.',
    },
    {
        question: "What happens if the license key doesn't cover all connected cameras?",
        answer: "You must purchase a license key that covers the total number of cameras connected to the NX server. If the license doesn't match the count, some functionality may be restricted or unavailable. If that is the case, reach out to sales@artoflogic.ai for further guidance.",
    },
    {
        question: "Where can I see validated license details?",
        answer: "Under the licensing-profile tab on the RONIN configuration interface.",
    },
    {
        question: "Where do I get technical support?",
        answer: "You can reach out to support@artoflogic.ai for technical support.",
    },
  ];

  export const vms = "Nx Witness";


// RBAC role-feature mappings. 'null' is when user has not created any businesses
export const accessControl = {
    'health-info-tab': ['tla', 'admin', 'supervisor', 'technician'],
    'port-cycle': ['tla', 'admin', 'technician'],
    'delete-offline-cameras': ['tla', 'admin', 'technician'],
    'site-map-upload': ['tla', 'admin'],
    'site-map-update': ['tla', 'admin'],
    'reports-tab': ['tla', 'admin', 'supervisor', 'technician'],
    'asset-lifecycle-tab': ['tla', 'admin', 'supervisor', 'technician'],
    'asset-lifecycle-view': ['tla', 'admin', 'supervisor', 'technician'],
    'asset-lifecycle-update-maintenance-server': ['tla', 'admin', 'supervisor'],
    'asset-lifecycle-update-maintenance-camera': ['tla', 'admin', 'supervisor'],
    'access-control-tab': ['tla', 'admin', 'supervisor'],
    'admin-tab': ['tla', 'admin', 'supervisor', 'technician'],
    'licenses-tab': ['tla', 'admin', 'supervisor', 'technician'],
    'create-new-licenses': ['tla'],
    'list-licenses': ['admin'],
    'suspend-reinstate-delete-license': ['tla'], 
    'sites-tab': ['tla', 'admin'],
    'edit-site': ['tla', 'admin'],
    'resources-tab': ['tla', 'admin', 'supervisor', 'technician']
};

// Check if given user role has access to the given feature/tab
export const canAccess = (feature, userRole) => {
    const allowedRole = accessControl[feature];
    if (!allowedRole) return false;
    return accessControl[feature].includes(userRole);
}




